export default "__VITE_ASSET__z67H9cf8RyOzF4$_4LMSXw__"